import PromineoCircle from "../../../../components/common/PromineoCircle";

interface Props {
  header: string;
  section1: string;
  section2: string;
}

export default function PromineoQuickStartSetps (props: Props) {
  const { header, section1, section2 } = props;

  return (
    <>
      <div className="flex">
        <div className="z-2">
        <PromineoCircle size={24}/>
        </div>
        <div className="ml-6 text-promBlack1 font-bold inline-block text-base font-inter">{header}</div>
      </div>
      <div className="ml-57 mt-4 text-promBlack1 text-base font-inter">
        {section1}
      </div>
      <div className="ml-57 mt-4 text-promBlack1 text-base font-inter">
        {section2}
      </div>
    </>
  );
}